// TODO: This file is not used, but it's a good example. Do we keep it?
import { mixThemes, type MixTheme } from "@/config/background"
import { defineStore } from "pinia"
import { reactive, ref, watch } from "vue"
import { controllersEvents, randomInRange } from "@/lib/utils"
import { useConfetti, CUSTOM_CONFIG } from "@/hooks/useConfetti"

export const useBackgroundStore = defineStore("background", () => {
  const initialTheme = { ...mixThemes.initial }

  const currentTheme = ref("intro")
  const theme: MixTheme = reactive(initialTheme)

  function setConfetti() {
    controllersEvents(() => {
      const interval = setInterval(() => {
        const origin = {
          x: randomInRange(10, 90) / 100,
          y: randomInRange(10, 90) / 100,
        }
        useConfetti().launchConfetti({ ...(CUSTOM_CONFIG as any), origin })
      }, 980)
      setTimeout(() => {
        clearInterval(interval)
      }, 5000)
    })
  }

  function setTheme(themeName: keyof typeof mixThemes) {
    currentTheme.value = themeName
    Object.assign(theme, mixThemes[themeName])

    return currentTheme.value
  }

  // Watch for theme and apply it to variables css
  watch(
    () => theme,
    async () => {
      document.documentElement.style.setProperty("--mix-opacity", "0")
      await new Promise((resolve) => setTimeout(resolve, 1000))

      for (const { key, value } of Object.values(theme)) {
        document.documentElement.style.setProperty(key, value)
      }

      document.documentElement.style.setProperty("--mix-opacity", "1")
    },
    { deep: true }
  )

  return { currentTheme, setTheme, setConfetti }
})
